module.exports = __webpack_public_path__ + "img/referto-3.5b22d588.jpg";